export default "/images/bank.svg?ccccdc7df123d6c1b91df2573b2265e9";